/* eslint-disable react/forbid-prop-types,react/require-default-props */

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { BootstrapModal } from '../../BootstrapModal/BootstrapModal';
import { ModalHeader, ModalBody, ModalFooter } from '../Helpers/index';
import { center, small } from './Dialog.scss';

/**
 * A simple React wrapper component for BootstrapModal to display a modal dialog.
 *
 * Potential code duplication: ReactModalDialog/ModalDialog/Dialog/BootstrapModal
 */

const ModalDialogWrappingCompDefaults = ({ children }) => <>{children}</>;

export const Dialog = React.memo(
  ({ ModalDialogWrappingComp = ModalDialogWrappingCompDefaults, ...props }) => {
    return (
      <BootstrapModal {...props}>
        <ModalDialogWrappingComp>
          <modal-dialog
            class={classNames({ [center]: props.center, [small]: props.small })}
          >
            <ModalHeader {...props} />
            <ModalBody>{props.children}</ModalBody>
            <ModalFooter {...props} />
          </modal-dialog>
        </ModalDialogWrappingComp>
      </BootstrapModal>
    );
  }
);
ModalDialogWrappingCompDefaults.propTypes = {
  children: PropTypes.any,
};
Dialog.propTypes = {
  ModalDialogWrappingComp: PropTypes.node,
  children: PropTypes.any,
  center: PropTypes.bool,
  small: PropTypes.bool,
};
Dialog.defaultProps = {
  center: false,
  small: false,
};
